/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartGanttCreate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 20V6h6V4H4V2H2v20h12v-2zM17 6h-6V4h6zm-4 4H6V8h7zm5 0h-4V8h4zm4 4H8v-2h14zm-12 2v2H6v-2zm8 2v-2h2v2h2v2h-2v2h-2v-2h-2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartGanttCreate as ChartGanttCreate };
